import React from 'react';
import classNames from 'classnames';
import Button from 'react-bootstrap/Button';
import { FormattedMessage } from 'react-intl';
import { Spinner } from 'react-bootstrap';
import PropdocsModal from '../../../modal/PropdocsModal';
import { OptionalMessageInputRef } from '../../document-wizard-modal/custom-modals/document-wizard-action-modal/OptionalMessageInputRef';
import { TitleFormattedMessage } from '../../../titleFormattedMessage';
import styles from './styles.module.scss';

interface LeaseDocumentWizardConfirmationModalProps {
  show: boolean;
  onHide: () => void;
  handleEdit: () => void;
  isUnsignPending: boolean;
  optionalMessageInputRef?: React.Ref<HTMLTextAreaElement>;
}

const REMOVE_SIGNATURES_MODAL =
  'If you cancel the signing session all signatures will be removed. Removing signatures is irreversible and will require signers to re-sign when the document is sent back for signing';

export const UnsignDocumentConfirmationModal = ({
  show,
  onHide,
  handleEdit,
  isUnsignPending,
  optionalMessageInputRef,
}: LeaseDocumentWizardConfirmationModalProps) => (
  <PropdocsModal
    show={show}
    setShow={onHide}
    size="lg"
    title={
      <FormattedMessage
        id="document-wizard-modal.unsign-confirmation-modal-title"
        defaultMessage="Cancel Signing"
      />
    }
    disableClose={isUnsignPending}
  >
    <>
      <section
        className={classNames('lease-document-wizard-unsign-confirmation-modal', styles.wrapper)}
        style={{ marginBottom: '1.5rem' }}
      >
        <FormattedMessage
          id="document-wizard-modal.lease-confirmation-content"
          defaultMessage={REMOVE_SIGNATURES_MODAL}
        />
      </section>
      <OptionalMessageInputRef ref={optionalMessageInputRef} />

      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem', paddingTop: '1.5rem' }}>
        <Button variant="outline-warning" onClick={onHide}>
          <TitleFormattedMessage
            id="document-wizard-modal.lease-confirmation-button-cancel"
            defaultMessage="Close"
          />
        </Button>
        <Button variant="warning" className={styles['edit-button']} onClick={handleEdit} disabled={isUnsignPending}>
          {isUnsignPending && <Spinner animation="border" size="sm" />}
          <TitleFormattedMessage
            id="document-wizard-modal.lease-confirmation-button-remove-signature"
            defaultMessage="Confirm"
          />
        </Button>
      </div>
    </>
  </PropdocsModal>
);
